import { useSelector } from "react-redux";
import { persistor, store, type RootState } from "./store";
import { clearAuthData, setAuthData } from "./slices/authSlice";

export const useUserDetails = () => {
  return useSelector((state: RootState) => state.auth);
};

export const updateAuthData = (data: Partial<RootState["auth"]>) => {
  const currentUser = store.getState().auth;
  store.dispatch(
    setAuthData({
      ...currentUser,
      ...data,
    }),
  );
};

export const removeAuthData = (): void => {
  store.dispatch(clearAuthData());
  persistor.purge();
};
